/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ link: NonNullable<unknown> }} Tfield_Markdown_SupportInputs */



/**
* | output |
* | --- |
* | "Supports {link} formatting" |
*
* @param {Tfield_Markdown_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_markdown_support = /** @type {((inputs: Tfield_Markdown_SupportInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Markdown_SupportInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supporte le format ${i?.link}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Admite formato ${i?.link}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Suporta formato ${i?.link}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Supporta formato ${i?.link}`)
	return /** @type {LocalizedString} */ (`Supports ${i?.link} formatting`)
});